<template>
  <div class="partner-area pt-100 pb-75">
    <div
      class="section-title mw-690 m-auto text-center"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay="100"
    >
      <span class="top-title">القنوات</span>
      <h2>استكشف قائمة القنوات التي نوفرها</h2>
    </div>

    <div class="container mw-1356">
      <div class="row justify-content-center">
        <div
          v-for="(channel, index) in channels"
          :key="index"
          class="col-xxl-2 col-sm-6 col-md-4"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="100 * ((index % 6) + 1)"
        >
          <RouterLink :to="channel.link" class="partner-bg mb-4">
            <img :src="channel.image" :alt="channel.name" />
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "ChannelList",
  setup() {
    const channels = ref([
      {
        name: "beIN SPORTS",
        image: require("@/assets/images/partner-1.png"),
        link: "/about-us",
      },
      {
        name: "OSN",
        image: require("@/assets/images/partner-2.png"),
        link: "/about-us",
      },
      {
        name: "MBC",
        image: require("@/assets/images/partner-3.png"),
        link: "/about-us",
      },
      {
        name: "Netflix",
        image: require("@/assets/images/partner-4.png"),
        link: "/about-us",
      },
      {
        name: "Shahid",
        image: require("@/assets/images/partner-5.png"),
        link: "/about-us",
      },
      {
        name: "Sky",
        image: require("@/assets/images/partner-6.png"),
        link: "/about-us",
      },
      {
        name: "ART",
        image: require("@/assets/images/partner-7.png"),
        link: "/about-us",
      },
      {
        name: "Rotana",
        image: require("@/assets/images/partner-8.png"),
        link: "/about-us",
      },
      {
        name: "Al Jazeera",
        image: require("@/assets/images/partner-9.png"),
        link: "/about-us",
      },
      {
        name: "Discovery",
        image: require("@/assets/images/partner-10.png"),
        link: "/about-us",
      },
      {
        name: "Nickelodeon",
        image: require("@/assets/images/partner-11.png"),
        link: "/about-us",
      },
    ]);

    return { channels };
  },
});
</script>